<div class="layout-container" [ngClass]="containerClass">

    <app-sidebar *ngIf="containerClassManage"></app-sidebar>
    <!-- BACKDROP -->
    <div class="layout-backdrop" *ngIf="isMobileMenuActive()" (touchstart)="onOverlayClick()"></div>

    <div class="layout-content-wrapper" [ngClass]="{'layout-content-wrapper': containerClassManage}">

        <app-topbar *ngIf="containerClassManage"></app-topbar>

        <app-breadcrumb class="content-breadcrumb" *ngIf="containerClassManage"></app-breadcrumb>
        <div class="layout-content" [ngClass]="{'layout-content': containerClassManage}">
            <router-outlet></router-outlet>
        </div>
    </div>

    <!-- footer DENTRO do container -->
    <!--
    <footer class="surface-card border-top-1 surface-border py-3">
        <div class="flex align-items-center justify-content-center">
            <img [src]="footerLogoSrc" alt="Slicksell" class="h-2rem" />
        </div>
    </footer>
    -->

    <app-profilemenu></app-profilemenu>
    <app-config></app-config>
    <div class="layout-mask"></div>
</div>